import { Document, Image, Page, Text, View } from '@react-pdf/renderer'
import { UserDTO } from '../../models/users'
import { dateFormatter } from '../../helpers/utils'
import { createTw } from 'react-pdf-tailwind'

interface Props {
    user: UserDTO
}

const tw = createTw({
    theme: {
        fontFamily: {
            sans: ['Comic Sans'],
        },
        extend: {
            colors: {
                custom: '#bada55',
            },
        },
    },
})

const PDF = ({ user }: Props) => {
    return (
        <Document>
            <Page size={'A4'}>
                <View style={tw('flex flex-col px-4 gap-4')}>
                    <View style={tw('flex flex-row pt-4 gap-4')}>
                        <Image
                            src={!!user.picture ? user.picture : '/adminPhoto.png'}
                            style={tw('w-[100px] h-[100px]')}
                        />
                        <Text style={tw('text-4xl mt-12')}>
                            {user.firstName + ' ' + user.lastName}
                        </Text>
                    </View>
                    <Text style={tw('text-2xl')}>Información Personal</Text>
                    <View style={{ borderBottomWidth: 1, width: '100%', marginTop: '-25px' }} />
                    <View>
                        <Text style={tw('text-xl')}>
                            Fecha de nacimiento: {dateFormatter(new Date(user.dateOfBirth))}
                        </Text>
                        <Text style={tw('text-xl')}>Email: {user.email}</Text>
                        <Text style={tw('text-xl')}>País: {user.nationality}</Text>
                        <Text style={tw('text-xl')}>Teléfono: {user.phone}</Text>
                        <Text style={tw('text-xl')}>
                            {user.livesAbroad ? 'Viviendo en el extranjero' : ''}
                        </Text>
                    </View>
                    <Text style={tw('text-2xl')}>Información Educacional</Text>
                    <View style={{ borderBottomWidth: 1, width: '100%', marginTop: '-25px' }} />
                    {user.educationalHistories.length > 0 &&
                        user.educationalHistories.map((info, index) => (
                            <View key={info.school}>
                                <View>
                                    <Text style={tw('text-xl')}>Grado: {info.degree}</Text>
                                    <Text style={tw('text-xl')}>Universidad: {info.school}</Text>
                                    <Text style={tw('text-xl')}>Carrera: {info.areaOfStudy}</Text>
                                    <Text style={tw('text-xl')}>País: {info.country}</Text>
                                    <Text style={tw('text-xl')}>
                                        Fecha de inicio: {dateFormatter(new Date(info.startDate))} -
                                        Fecha de fin:{' '}
                                        {info.endDate
                                            ? dateFormatter(new Date(info.endDate))
                                            : 'Presente'}
                                    </Text>
                                </View>
                                {index < user.educationalHistories.length - 1 && (
                                    <View style={{ borderBottomWidth: 0.5, width: '100%' }} />
                                )}
                            </View>
                        ))}
                    <Text style={tw('text-2xl')}>Información Profesional</Text>
                    <View style={{ borderBottomWidth: 1, width: '100%', marginTop: '-25px' }} />
                    {user.workHistories.length > 0 &&
                        user.workHistories.map((info, index) => (
                            <View key={info.employerName}>
                                <View>
                                    <Text style={tw('text-xl')}>Empresa: {info.employerName}</Text>
                                    <Text style={tw('text-xl')}>País: {info.employerCountry}</Text>
                                    <Text style={tw('text-xl')}>Puesto: {info.jobTitle}</Text>
                                    <Text style={tw('text-xl')}>
                                        Responsabilidades: {info.description}
                                    </Text>
                                    <Text style={tw('text-xl')}>
                                        Trabajo actual: {info.currentJob ? 'Si' : 'No'}
                                    </Text>
                                    <Text style={tw('text-xl')}>
                                        Fecha de inicio: {dateFormatter(new Date(info.startDate))} -
                                        Fecha de fin:{' '}
                                        {info.endDate
                                            ? dateFormatter(new Date(info.endDate))
                                            : 'Presente'}
                                    </Text>
                                </View>
                                {index < user.workHistories.length - 1 && (
                                    <View style={{ borderBottomWidth: 0.5, width: '100%' }} />
                                )}
                            </View>
                        ))}
                    <Text style={tw('text-2xl')}>Aptitudes</Text>
                    <View style={{ borderBottomWidth: 1, width: '100%', marginTop: '-25px' }} />
                    <Text style={tw('text-xl')}>{user.allAbilities.join(', ')}</Text>
                </View>
            </Page>
        </Document>
    )
}

export default PDF
